import { BLAZE_DEBUG, BLAZE_PB_EDITOR_MODE } from '../constants';
import getFromLocal from './get-from-local';
const setBlazeDebug = setIsDebugMode => {
  if (typeof window === 'undefined') return;
  const {
    localStorage,
    location
  } = window;
  const params = new URLSearchParams(location.search);
  window.blaze = window.blaze || {};
  window.blaze.debug = () => {
    const stored = getFromLocal(BLAZE_DEBUG);
    if (stored) {
      localStorage.removeItem(BLAZE_DEBUG);
      window.localStorage.removeItem(BLAZE_PB_EDITOR_MODE);
      setIsDebugMode(false);
    } else {
      localStorage.setItem(BLAZE_DEBUG, 'true');
      setIsDebugMode(true);
    }
  };
  if (params.get(BLAZE_DEBUG) === '1') {
    localStorage.setItem(BLAZE_DEBUG, 'true');
    setIsDebugMode(true);
    return;
  }
  const stored = JSON.parse(localStorage.getItem(BLAZE_DEBUG));
  setIsDebugMode(!!stored);
};
export default setBlazeDebug;
//# sourceMappingURL=set-blaze-debug.js.map